import { KnaufPlaster } from './knauf-plaster.enum';
import { Injectable } from '@angular/core';
import { Plaster, KnaufPlasters } from './plaster';

@Injectable({
  providedIn: 'root'
})
export class PlasterService {

  constructor() { }

  getKnaufPlaster(plaster: KnaufPlaster): Plaster {
    return KnaufPlasters[plaster];
  }
}
